import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { changeBreadcrumbList, changePageSubtitle, changePageTitle, changeSaludo } from '../Infraestructure/SliceGenerico';

interface PropsViewMain {
    list: Array<{ text: string; navigate: boolean; path: string }>;
    title?: string;
    subtitle?: string;
    children?: JSX.Element;
};

export const ElementBreadCrumb = ({ list, title, subtitle, children }: PropsViewMain) => {
    const dispatch: Dispatch = useDispatch();
    const currentText = list[list.length - 1]?.text || '';
    const breadcrumbKey = list.map(row => `${row.text}:${row.path}:${row.navigate}`).join('|');

    useEffect(() => {
        dispatch(changeSaludo(true));
        dispatch(changePageTitle(title || currentText));
        dispatch(changePageSubtitle(subtitle || ''));
        dispatch(changeBreadcrumbList(list));
        // eslint-disable-next-line
    }, [title, subtitle, currentText, breadcrumbKey]);

    return children || null;
};
